import React from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';
import MissionsSection from '../components/sections/MissionsSection';
import ExpertiseSection from '../components/sections/ExpertiseSection';
import AboutSection from '../components/sections/AboutSection';
import ContactSection from '../components/sections/ContactSection';

const HomePage: React.FC = () => {
  return (
    <Box>
      <HeroSection />
      <ServicesSection />
      <MissionsSection />
      <ExpertiseSection />
      <AboutSection />
      <ContactSection />
    </Box>
  );
};

export default HomePage;